var _style, _polygon, _rect, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke-width:25;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,71.803;}\r\n\t.st3{fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,84.696;}\r\n\t.st4{fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,74.1093;}\r\n\t.st5{fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,77.7465;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "235.8,824.4 172.9,761.5 141.6,767.5 113.7,795.4 201.9,883.6 229.8,855.7 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 597.1,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 586.9435 6.6379)",
    className: "st0",
    width: 88.9,
    height: 229.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M821.3,175.9c-163.5-163.5-377.2-75.4-406.6,54.5s-78.6,369.9-78.6,369.9l60.8,60.8c0,0,240-49.2,369.9-78.6 C896.8,553.2,984.8,339.4,821.3,175.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427.4,399.1l170.8,170.8c56.4-12,113.8-24.4,158.1-34.3c43.8-9.9,82.4-51.7,98.2-106.4 c21.7-74.8-2.8-154.7-67.2-219.1s-144.2-88.9-219.1-67.2c-54.8,15.8-96.5,54.4-106.4,98.2C451.8,285.3,439.4,342.7,427.4,399.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 601.5,
    y1: 191.9,
    x2: 601.5,
    y2: 191.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 652.2,
    y1: 242.7,
    x2: 779.2,
    y2: 369.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 804.6,
    y1: 395,
    x2: 804.6,
    y2: 395
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 678.8,
    y1: 197.9,
    x2: 678.8,
    y2: 197.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 738.7,
    y1: 257.8,
    x2: 768.6,
    y2: 287.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 798.6,
    y1: 317.7,
    x2: 798.6,
    y2: 317.7
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 562.5,
    y1: 224.3,
    x2: 562.5,
    y2: 224.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 614.9,
    y1: 276.7,
    x2: 746,
    y2: 407.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 772.2,
    y1: 433.9,
    x2: 772.2,
    y2: 433.9
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 526.9,
    y1: 259.9,
    x2: 526.9,
    y2: 259.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 579.3,
    y1: 312.3,
    x2: 710.3,
    y2: 443.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 736.5,
    y1: 469.6,
    x2: 736.5,
    y2: 469.6
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 514.6,
    y1: 319.3,
    x2: 514.6,
    y2: 319.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 569.7,
    y1: 374.2,
    x2: 652.3,
    y2: 456.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 679.9,
    y1: 483.9,
    x2: 679.9,
    y2: 483.9
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 500.5,
    y1: 376.2,
    x2: 500.5,
    y2: 376.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 560.4,
    y1: 436.1,
    x2: 590.3,
    y2: 466
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 620.3,
    y1: 496,
    x2: 620.3,
    y2: 496
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 597.2,
    cy: 822.5,
    r: 114.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M516.4,741.6c0,0,57.6,73.5,0,161.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M678,741.6c0,0-57.6,73.5,0,161.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadel);
export default __webpack_public_path__ + "static/media/Padel.f6206c6f.svg";
export { ForwardRef as ReactComponent };